import React, { Component } from 'react';
import { connect } from 'react-redux';
import SidebarList from 'features/Admin/components/SidebarList';
import ElementFocus from 'features/Admin/components/ElementFocus';
import {
	adminGetEmergencyReason,
	adminGetAllEmergencyReasons,
	resetFocusEmergencyReason,
	initNewEmergencyReason,
	adminPatchEmergencyReason,
	adminPostEmergencyReason,
	adminDeleteEmergencyReason,
} from 'services/emergencyReason';
import AdminDataContainer from 'features/Admin/components/AdminDataContainer';
import { Grid, Icon } from 'semantic-ui-react';
import RedButton from 'components/Buttons/RedButton';
import GeneralForm from 'features/Admin/EmergencyReasons/Forms/GeneralForm';
import { Form, Formik } from 'formik';
import MainButton from 'components/Buttons/MainButton';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import * as Yup from 'yup';

const schemaValidation = Yup.object().shape({
	label: Yup.string().required('Champ requis'),
	order: Yup.number().required('Champ requis'),
});

class EmergencyReasonsAdmin extends Component {
	componentDidMount() {
		this.getAllElements();
	}

	componentWillUnmount() {
		this.props.resetFocusEmergencyReason();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {}

	getAllElements = () => {
		this.props.adminGetAllEmergencyReasons();
	};

	focusOnElement = (elt) => {
		this.props.adminGetEmergencyReason(elt);
	};

	onAddClick = () => {
		this.props.initNewEmergencyReason();
	};

	saveFocus = (values, setSubmitting) => {
		if (values.id === undefined) {
			delete values.id;
			this.props.adminPostEmergencyReason(values).then(() => {
				setSubmitting(false);
			});
		} else {
			this.props.adminPatchEmergencyReason(values).then(() => {
				setSubmitting(false);
			});
		}
	};

	deleteFocus = () => {
		this.props.adminDeleteEmergencyReason(
			this.props.emergencyReasons.focus.data
		);
	};

	render() {
		const { emergencyReasons } = this.props;
		const { focus, list } = emergencyReasons;
		const emergencyReason = focus.data;
		const newEmergencyReason =
			emergencyReason !== null && emergencyReason.id === undefined;

		return (
			<div style={styles.adminContainer}>
				<SidebarList
					list={emergencyReasons.list}
					categories={[]}
					onElementClick={this.focusOnElement}
					entity="MOTIF D'URGENCE"
					addButtonText="Nouveau motif d'urgence"
					onAddButtonClick={this.onAddClick}
					defaultLabel={(e) => e.label}
					groupField={false}
					focusedEltId={emergencyReason}
				/>

				<ElementFocus
					element={focus}
					list={list}
					entity="Motif d'urgence"
					icon='info'
				>
					{emergencyReason !== null && (
						<Formik
							enableReinitialize
							initialValues={{
								id: emergencyReason.id,
								label: emergencyReason.label || '',
								order: emergencyReason.order || 1,
							}}
							validationSchema={schemaValidation}
							onSubmit={(values, { setSubmitting }) => {
								this.saveFocus(values, setSubmitting);
							}}
						>
							{({ isSubmitting, errors }) => (
								<Form>
									<Grid style={{ margin: 0 }}>
										<Grid.Row columns={1}>
											<Grid.Column>
												<SecondaryButton
													type='button'
													style={{ float: 'left' }}
													onClick={this.props.resetFocusEmergencyReason}
												>
													Fermer
												</SecondaryButton>
												<MainButton
													text={<Icon name='save' />}
													type='submit'
													style={{ float: 'left' }}
													isSubmitting={isSubmitting}
													disabled={
														Object.entries(errors).length > 0 &&
														errors.constructor === Object
													}
												>
													{newEmergencyReason ? 'Créer' : 'Enregistrer'}
												</MainButton>

												{!newEmergencyReason && (
													<RedButton
														text={<Icon name='trash' />}
														type='button'
														onClick={(e) => {
															if (e !== undefined) e.preventDefault();
															this.deleteFocus();
														}}
														style={{ float: 'right' }}
													>
														Supprimer
													</RedButton>
												)}
											</Grid.Column>
										</Grid.Row>

										<Grid.Row columns={1}>
											<Grid.Column>
												<AdminDataContainer
													ribbonColor='red'
													ribbonLabel='Général'
												>
													<GeneralForm />
												</AdminDataContainer>
											</Grid.Column>
										</Grid.Row>
									</Grid>
								</Form>
							)}
						</Formik>
					)}
				</ElementFocus>
			</div>
		);
	}
}

const styles = {
	adminContainer: {
		height: '100%',
		width: '100%',
		paddingTop: 43,
		fontSize: 0,
		display: 'flex',
	},
	blocHeader: {
		backgroundColor: 'rgb(0, 147, 128)',
		padding: 10,
		width: '100%',
		borderRadius: '4px 4px 0 0',
	},
};

const mapStateToProps = (state) => {
	return {
		emergencyReasons: state.admin.emergencyReasons,
	};
};

const mapDispatchToProps = {
	adminGetAllEmergencyReasons,
	adminGetEmergencyReason,
	adminPatchEmergencyReason,
	adminDeleteEmergencyReason,
	resetFocusEmergencyReason,
	adminPostEmergencyReason,
	initNewEmergencyReason,
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(EmergencyReasonsAdmin);
